import cloudinaryInstance from './instance'

const storeImageToCloudinary = (cloudname, formData) => {
	return cloudinaryInstance.post(`/${cloudname}/auto/upload`, formData)
}

export default storeImageToCloudinary
